import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useSession, getSessionBrand } from '../../infra/session';
import { RenewAppleLicencePopup } from './renew-apple-licence-popup';
import { FullstoryService } from '../../infra/observability/fullstory';
import { useFeatureFlags } from '../../infra/feature-flags';
import { didEnoughTimePass, setLastInteractionDate } from '../../infra/persistence/interactionStateUtils';
export var STORAGE_KEY = '__apple_renew_agreement_dismissed_ts';
export var SHOW_AGAIN_THRESHOLD = 7 * 24; // 7 days
export var RenewAppleLicenceContainer = function () {
    var session = useSession().data;
    var _a = useState(false), isVisible = _a[0], setIsVisible = _a[1];
    var isFeatureEnabled = useFeatureFlags().appleAgreementBanner;
    useEffect(function () {
        if (session && isFeatureEnabled) {
            var brand = getSessionBrand(session);
            var doesNeedToRenewAppleLicence = !!brand.extension.appleAccountNeedsAttention;
            if (doesNeedToRenewAppleLicence && didEnoughTimePass(STORAGE_KEY, SHOW_AGAIN_THRESHOLD)) {
                setIsVisible(true);
                FullstoryService.track('Apple license agreement popup displayed');
            }
        }
    }, [session, isFeatureEnabled]);
    var handleDismiss = function () {
        setIsVisible(false);
        setLastInteractionDate(STORAGE_KEY);
        FullstoryService.track('Apple license agreement popup dismissed');
    };
    var handleOpen = function () {
        setIsVisible(false);
        setLastInteractionDate(STORAGE_KEY);
        FullstoryService.track('Apple license agreement popup clicked');
    };
    if (!isVisible) {
        return null;
    }
    return _jsx(RenewAppleLicencePopup, { onDismiss: handleDismiss, onAccept: handleOpen });
};
